import React, { useEffect, useState } from "react";
import { strings } from "../utils";
import { Link } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button } from "../components";
import {
  fetchCategories,
  fetchBlogsByCategory,
  getCurrentUser,
} from "../utils/methods";
import { useNavigate } from "react-router-dom";
import ResetLink from "../content/Login/ResetPassword";

const HrWikipedia = () => {
  const [categories, setCategories] = useState([]);
  const [blogsByCategory, setBlogsByCategory] = useState({});
  const [userDesignation, setUserDesignation] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadCategories = async () => {
      const fetchedCategories = await fetchCategories();
      setCategories(fetchedCategories);

      const user = await getCurrentUser();
      setUserDesignation(user.designation);
    };

    loadCategories();
  }, []);

  useEffect(() => {
    const loadBlogs = async () => {
      const blogsData = {};

      for (let category of categories) {
        const blogs = await fetchBlogsByCategory(category);
        blogsData[category] = blogs;
      }

      setBlogsByCategory(blogsData);
    };

    if (categories.length > 0) {
      loadBlogs();
    }
  }, [categories]);

  const handleAddHrBlog = () => navigate(`/wikkipedia/edit/new`);

  return (
    <div className="container px-auto py-6 bg-border h-full overflow-scroll">
      <div className="flex justify-between mx-10 mb-8">
        <p className="text-[32px] font-semibold">{strings["hrWikipedia"]}</p>
        <div>
          {(userDesignation === "ADMIN" || userDesignation === "HR") && (
            <Button
              classes="border-primary text-primary !w-full justify-center"
              onClick={handleAddHrBlog}
            >
              {strings["AddWikiBtn"]}
            </Button>
          )}
        </div>
      </div>
      <div className="mx-10 space-y-6">
        {categories.map((category, index) => (
          <Accordion
            key={index}
            sx={{
              border: "none",
              backgroundColor: "white",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
              // borderRadius: "16px",
              "&::before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index + 1}-content`}
              id={`panel${index + 1}-header`}
              sx={{
                borderRadius: "16px",
                "&:hover": { backgroundColor: "transparent" },
              }}
            >
              <p className="text-xl font-semibold">{category}</p>
            </AccordionSummary>
            <AccordionDetails>
              <div className="grid grid-cols-1 gap-y-6 md:grid-cols-3 md:gap-x-4">
                {blogsByCategory[category]?.length > 0 ? (
                  blogsByCategory[category].map((blog) => (
                    <Link to={`/wikipedia/${blog.id}`}>
                      <div
                        key={blog.id}
                        className="flex items-center gap-x-3 border border-border p-2 rounded-md cursor-pointer hover:border-primary"
                      >
                        <img
                          src={blog.blogImage}
                          alt="No Image"
                          className="w-6 h-6"
                        />
                        <p className="text-base font-medium text-color-1">
                          {blog.title}
                        </p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <p className="text-base font-medium text-color-1">
                    No Wikipedia available
                  </p>
                )}
              </div>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      <ResetLink />
    </div>
  );
};

export default HrWikipedia;
